export enum TablasBD {
  // TABLAS PARA CATALOGOS
  cat_estado_civil = 'cat_estado_civil',
  cat_geo_entidades = 'cat_geo_entidades',
  cat_regimen_conyugal = 'cat_regimen',
  cat_nivel_estudios = 'cat_nivel_estudios',
  cat_identificacion = 'cat_identificacion',
  cat_tipo_vive_zona = 'cat_tipo_vive_zona',
  cat_tipo_vivienda = 'cat_tipo_vivienda',
  cat_domicilio_vive = 'cat_domicilio_vive',
  cat_domicilio_tipo_comprobante = 'cat_domicilio_tipo_comprobante',
  cat_tipo_vialidad = 'cat_tipo_vialidad',
  cat_tipo_casa = 'cat_tipo_casa',
  cat_tipo_asentamiento = 'cat_tipo_asentamiento',
  cat_tipo_ocupacion = 'cat_tipo_ocupacion',
  cat_tipo_domicilio = 'cat_tipo_domicilio',
  cat_empresa_relacion = 'cat_empresa_relacion',
  cat_empresas_convenio = 'cat_empresas_convenio',
  cat_empresas_convenio_contrato = 'cat_empresas_convenio_contrato',
  cat_categorizacion_servicios_simulador = 'cat_categorizacion_servicios_simulador',
  //CATALOGOS DE PRESTAMOS
  cat_tipo_prestamos = 'cat_tipo_prestamos',
  cat_tipo_prestamos_periodos = 'cat_tipo_prestamos_periodos',
  cat_periodos = 'cat_periodos',
  // TABLAS PARA INFORMACION DEL ACREDITADO
  cat_usuarios_web = 'cat_usuarios_web',
  cat_contacto = 'cat_contacto',
  cat_personas = 'cat_personas',
  cat_domicilio = 'cat_domicilio',
  cat_laboral_socio = 'cat_laboral_socio',
  cat_conyugue = 'cat_conyugue',
  cat_personas_socioeconomicos_ingresos_egresos = 'cat_personas_socioeconomicos_ingresos_egresos',
  cat_tipo_ingreso_gastos = 'cat_tipo_ingreso_gastos',
  pld_cat_personas_peps_cuestionario = 'pld_cat_personas_peps_cuestionario',

  cat_planteles = 'cat_planteles',

  //TABLAS DE GEOLOCALIZACIÓN
  cat_geo_municipios = 'cat_geo_municipios',
  cat_geo_localidades = 'cat_geo_localidades',

  // CATALOGOS USADOS PARA CONTACTO
  cat_tipo_contacto = 'cat_tipo_contacto',

  //TABLAS PARA PLD
  pld_paises = 'pld_paises',
  pld_giro_actividad = 'pld_giro_actividad',

  //TABLAS PARA CONFIGURACION DE ENTIDAD
  configuracion_empresa = 'configuracion_empresa',
  cat_dias_inhabiles = 'cat_dias_inhabiles',
  cat_dias_inhabiles_semana = 'cat_dias_inhabiles_semana',
  configuracion_correo ='configuracion_correo',
  //Tablas solicitudes
  prestamos_solicitudes = 'prestamos_solicitudes',
  datos_empresa = 'datos_empresa',

  cat_acceso_base = 'cat_acceso_base',

  // Tabla creación de socio
  cat_socios = 'cat_socios',
  cat_empresas_convenio_empleados = 'cat_empresas_convenio_empleados',
  cat_cliente = 'cat_cliente',
  prestamos = 'prestamos',
  bitacora_consulta_prestamos_control = 'bitacora_consulta_prestamos_control',
  bitacora_consulta_prestamos_json = 'bitacora_consulta_prestamos_json',
  movimiento_otros_ingresos = 'movimiento_otros_ingresos' ,
  cat_otros_ingresos = 'cat_otros_ingresos',
  prestamos_garantias = 'prestamos_garantias',
  cat_empleados = 'cat_empleados',
  movimiento_abonos = 'movimiento_abonos',
  prestamos_pagos = 'prestamos_pagos',
  prestamos_pagos_servicios_adicionales = 'prestamos_pagos_servicios_adicionales',
  prestamos_servicios_adicionales = 'prestamos_servicios_adicionales',
  cat_tipo_movimiento = 'cat_tipo_movimiento',
  cat_forma_pago = 'cat_forma_pago',
  movimiento_folios = 'movimiento_folios',
  cat_usuarios = 'cat_usuarios',
  cat_prestamos_estatus = 'cat_prestamos_estatus',
  cat_tipo_segmento = 'cat_tipo_segmento',

  //SECCIÓN DE TABLAS QUE VIENEN CON PREFIJO PLD
  pld_cat_personas_informacion_empresa = 'pld_cat_personas_informacion_empresa',

  //INFORMACIÓN PARA CONSULTA DE PARAMETROS DE BURO DE CREDITO
  cat_parametros_buro = 'cat_parametros_buro',
  bitacora_consulta_buro = 'bitacora_consulta_buro',
}